<mat-card class="main-card">
  <div class="header">
    <div class="title">
      <h2>{{ lastName }} {{ firstName }}</h2>
      {{ email }} - {{ "ADMINS.REGISTERED" | translate }} {{ regDate | date }}
    </div>
    <div class="d-flex">
      <a
        mat-icon-button
        class="filled"
        color="primary"
        [routerLink]="['/account/users/edit', id]"
      >
        <mat-icon>edit</mat-icon>
      </a>
      <app-delete-button
        *ngIf="isRemoveVisible"
        (delete)="delete()"
      ></app-delete-button>
    </div>
  </div>
  <mat-card-content>
    <p>{{ "ADMINS.TITLE.ROLES" | translate }}:</p>
    <mat-chip-listbox>
      <mat-chip
        class="easy-chip"
        *ngFor="let role of roles"
        [matTooltip]="'ADMINS.ROLES_HINT.' + role | translate"
        [attr.aria-readonly]="true"
      >
        {{ "ADMINS.ROLES." + role | translate }} &nbsp;
        <mat-icon>info</mat-icon>
      </mat-chip>
    </mat-chip-listbox>
  </mat-card-content>
</mat-card>
